import React from 'react'
import ImportItemsInput from './ImportItemsInput'
import ImportItemsView from './ImportItemsView'
import { Button, Modal, ModalHeader, ModalFooter } from 'reactstrap'
import apiBarcode from '../../services/api/apiBarcode'
import whl from '../../configs/whl'
import { getListSku } from "../../services/api/apiSku"
import { Spin } from "antd"

class ImportItemsPage extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            items: [],
            isLoadingImport: false,
            modal: false,
            listSkuActive: [],
            loading: false,
            error: ''
        }
    }

    _setModal = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    _changeLabelsInput = (items) => {
        this.setState({ items })
    }

    _formatItem = (item) => {
        const makeWHL = (products) => {
            let height = 0, length = 0, weight = 0, width = 0
            let tile_count = 0
            let poster_count = 0
            let poster_box = { 'length': 0, 'width': 0, 'height': 0, 'weight': 0 }

            for (let product of products) {
                const { type, size } = product
                const typeU = type ? type.toUpperCase() : 'T-SHIRT'
                const sizeU = size ? size.toUpperCase() : ''
                if (whl.hasOwnProperty(typeU)) {
                    if (typeU === 'TILE') {
                        tile_count = tile_count + 1
                        continue
                    }
                    const sizes = whl[typeU]
                    const rsize = sizes.hasOwnProperty(sizeU) ? sizeU : size
                    const isize = sizes.hasOwnProperty(rsize) ? sizes[rsize] : sizes['DEFAULT']
                    const { 'weight': iWeight, 'length': iLength, 'width': iWidth, 'height': iHeight } = isize
                    if (typeU === 'POSTER') {
                        poster_count = poster_count + 1
                        if (poster_box.length < iLength) poster_box.length = iLength
                        if (poster_box.width < iWidth) poster_box.width = iWidth
                        if (poster_box.height < iHeight) poster_box.height = iHeight
                        if (poster_box.weight < iWeight) poster_box.weight = iWeight
                    } else {
                        if (length < iLength) length = iLength
                        if (width < iWidth) width = iWidth
                        height += iHeight
                        weight += iWeight
                    }
                } else {
                    const tHeight = 50, tLength = 200, tWidth = 150, tWeight = 180
                    if (length < tLength) length = tLength
                    if (width < tWidth) width = tWidth
                    if (height < tHeight) height = tHeight
                    weight += tWeight
                }
            }

            if (poster_count) {
                if (length < poster_box.length) length = poster_box.length
                if (width < poster_box.width) width = poster_box.width
                height += poster_box.height
                weight += poster_box.weight
            }

            if (tile_count) {
                if (tile_count > 5) {
                    var box5 = Math.floor(tile_count / 5)
                    const {
                        'weight': tilebox5_Weight,
                        'length': tilebox5_Length,
                        'width': tilebox5_Width,
                        'height': tilebox5_Height
                    } = whl['TILE']['TILE_5']

                    if (length < tilebox5_Length) length = tilebox5_Length

                    if (width < tilebox5_Width) width = tilebox5_Width
                    height += (tilebox5_Height * box5)
                    weight += (tilebox5_Weight * box5)

                    var boxx_size = tile_count % 5

                    if (boxx_size) {
                        const {
                            'weight': tileboxx_Weight,
                            'length': tileboxx_Length,
                            'width': tileboxx_Width,
                            'height': tileboxx_Height
                        } = whl['TILE']['TILE_' + boxx_size]
                        if (length < tileboxx_Length) length = tileboxx_Length
                        if (width < tileboxx_Width) width = tileboxx_Width
                        height += tileboxx_Height
                        weight += tileboxx_Weight
                    }
                } else {
                    const {
                        'weight': tilebox_Weight,
                        'length': tilebox_Length,
                        'width': tilebox_Width,
                        'height': tilebox_Height
                    } = whl['TILE']['TILE_' + tile_count]
                    if (length < tilebox_Length) length = tilebox_Length
                    if (width < tilebox_Width) width = tilebox_Width
                    height += tilebox_Height
                    weight += tilebox_Weight
                }
            }

            console.log('===================================')
            console.log({ height, length, weight, width })
            console.log('===================================')

            return { height, length, weight, width }

        }

        const makeItems = (products) => {
            return products.map(product => {
                const { type, size } = product
                const typeU = type ? type.toUpperCase() : ''
                const sizeU = size ? size.toUpperCase() : ''

                return {
                    itemDescription: `${typeU} SIZE ${sizeU}`,
                    packagedQuantity: 1,
                    skuNumber: `${typeU}${sizeU}`.replace(/\W+/g, '')
                }
            })
        }

        return {
            ...item,
            ...makeWHL(item.products),
            items: makeItems(item.products)
        }
    }

    _isValidJSON = (text) => {
        try {
            JSON.parse(text)
            return true
        } catch (e) {
            return false
        }
    }

    _handleClickImport = async () => {
        this.setState({ isLoadingImport: true })

        try {
            const { items } = this.state
            const itemsFinal = items.map(item => {
                const { return_address1, return_address2, return_city, return_countryCode, return_email, return_name, return_phone, return_postalCode, return_state, product_print_file_json, ...itemNotRA } = item

                if (product_print_file_json && !this._isValidJSON(product_print_file_json)) {

                    throw Error(`product_print_file_json is not valid JSON`)
                }

                if (return_address1 || return_address2 || return_city || return_countryCode || return_email || return_name || return_phone || return_postalCode || return_state) {
                    const returnAddress = {
                        name: return_name,
                        country: return_countryCode,
                        state: return_state,
                        address1: return_address1,
                        city: return_city,
                        postalCode: return_postalCode,
                        email: return_email,
                        phone: return_phone,
                        address2: return_address2
                    }

                    return { ...itemNotRA, 'return_address': returnAddress }
                } else {
                    return { ...itemNotRA }
                }
            })

            const itemsFormatted = itemsFinal.map(item => this._formatItem(item))
            const resCreated = await apiBarcode.importListBarcode(itemsFormatted)
            const { success, message } = resCreated.data

            if (!success) throw new Error(message)

            this.setState({ isLoadingImport: false, modal: true })
        } catch (e) {
            alert(e.message)
            this.setState({ isLoadingImport: false })
        }
    }

    _renderLoadingImport = () => {
        if (this.state.isLoadingImport)
            return <i className='icon-spinner2 spinner ml-2' />
    }

    _fetchListSku = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                limit: 1000,
                page: 1,
                sort: "-created_at",
                name: "",
                sku: "",
                is_active: "true"
            }

            const { data: response } = await getListSku(payload)

            const { success, data, message } = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                })
            }

            this.setState({
                loading: false
            }, () => {
                const listSkuPrefix = data.items.map(item => item.sku)

                this.setState({
                    listSkuActive: listSkuPrefix
                })
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    componentDidMount() {
        this._fetchListSku()
    }

    render() {
        const { items, isLoadingImport, modal, listSkuActive, loading, error } = this.state

        return (
            <div className='ImportItemsPage'>
                <Spin spinning={loading} tip='Đang lấy thông tin SKU...'>
                    <ImportItemsInput listSkuActive={listSkuActive} onChange={this._changeLabelsInput} />

                    <ImportItemsView items={items} />

                    <div className='text-right'>
                        <Button
                            color='primary'
                            onClick={this._handleClickImport}
                            disabled={isLoadingImport || !items.length}
                        >
                            <i className='icon-download4 mr-2' />
                            Import
                            {this._renderLoadingImport()}
                        </Button>
                    </div>

                    {modal && (
                        <Modal isOpen={modal} toggle={this._setModal}>
                            <ModalHeader toggle={this._setModal}>Import thành công!</ModalHeader>
                            <ModalFooter>
                                <Button color="primary" onClick={this._setModal}>Đóng </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </Spin>

                {
                    !!error && error.length > 0 && <div className="text-danger">{error}</div>
                }
            </div>
        )
    }
}

export default ImportItemsPage
